import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';
import { AllChatItem, ChatUser, User } from 'src/app/services/model/types';
import { NotificationService } from 'src/app/services/notification.service';
import { forkJoin } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
@Component({
  selector: 'app-cross-chat',
  templateUrl: './cross-chat.component.html',
  styleUrls: ['./cross-chat.component.css'],
})
export class CrossChatComponent implements OnInit {
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
  chat: any[] = [];
  postChat: any[] = [];
  chatStatus: boolean = false;
  activeTab: string = 'Public';
  loginUser: string = '';
  loginUserName: string = '';
  newMessage: string = '';
  userName: string = '';
  chatUserImage: string = '';
  userProfile: string = '';
  contactUser: any = '';
  postId: string = '';
  searchValue: string = '';
  socket: any;
  allUser: ChatUser[];
  chatType: string;
  chatId: string;
  merchantChat: any[] = [];
  allChat: AllChatItem[] = [];
  friends: User[] = [];
  publicUsers: User[] = [];
  affiliateUsers: User[] = [];
  selectedTab: string = '';
  receiverId: any = '';
  messages: any = [];
  newChatUser: User[] = [];
  partnersUserList: User[] = [];
  allTabsUserList: User[] = [];
  showNewChatList: boolean = false;
  showNewChatDropdown: boolean = false;
  activeUser: User[]=[];
  activeMessageSenderId: string=''
  searchTerm: string = '';
  cachedSearchResult:User[]=[]

  constructor(
    private authService: AuthservicesService,
    private socketService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    let userString = localStorage.getItem('ministry_currentUser') || null;
    if (userString) {
      let loginUser = JSON.parse(userString);
      this.loginUser = loginUser.id || loginUser._id;
      this.loginUserName = loginUser?.['name'] || 'Unknown';
      this.setupSocketConnection();
    }
    this.getUserFriendsList();
  }
  ngOnDestroy(): void {
    this.socketService.disconnect();
  }
  setupSocketConnection() {
    this.socketService.connect(this.loginUser);
    this.socketService.emit('join', this.loginUser);
    this.socketService.on('chatMessage').subscribe((data: any) => {
      if(this.loginUser === data.receiverId)
      {
        this.activeMessageSenderId=data.senderId
        this.cdr.detectChanges();
      }
      if (data.senderId != this.loginUser) {
        this.chat = [...this.chat, data];
      }
      this.cdr.detectChanges()
      setTimeout(() => this.scrollToBottom(), 0);
    });
  }
  //search terms
filterUsers() {
  const term = this.searchTerm?.toLowerCase() || '';

  // choose the current tab's live list as the base (no stale cache)
  let base: User[] = [];
  switch (this.activeTab) {
    case 'People':
      base = [...(this.friends || [])];
      break;
    case 'Public':
      base = [...(this.publicUsers || [])];
      break;
    case 'Affiliate':
      base = [...(this.affiliateUsers || [])];
      break;
    case 'Merchants':
      base = [...(this.partnersUserList || [])];
      break;
    case 'Partners':
    case 'Ministries':
      base = [...(this.partnersUserList || [])];
      break;
    case 'all':
      base = [...(this.allTabsUserList || [])];
      break;
  }

  const filtered = term
    ? base.filter((user: any) => {
        const name = (
          user?.name ||
          user?.userName ||
          `${user?.firstName || ''} ${user?.lastName || ''}`
        )
          .toString()
          .trim()
          .toLowerCase();
        return name.includes(term);
      })
    : base;

  // update only the active tab list
  switch (this.activeTab) {
    case 'People':
      this.friends = filtered;
      break;
    case 'Public':
      this.publicUsers = filtered;
      break;
    case 'Affiliate':
      this.affiliateUsers = filtered;
      break;
    case 'Merchants':
      this.partnersUserList = filtered;
      break;
    case 'Partners':
    case 'Ministries':
      this.partnersUserList = filtered;
      break;
    case 'all':
      this.allTabsUserList = filtered;
      break;
  }
}


  // display all member of the chat (optionally by type)
  newChat(type?: 'user' | 'merchant' | 'fellowship' | 'affiliates' | 'ministries') {
    this.chatStatus = false;
    // close dropdown if open
    this.showNewChatDropdown = false;
    this.authService
      .getData(`/user/getUserFriends?role=ministries&selectedTab=${type}&tab=newChat`)
      .subscribe((res: any) => {
        this.newChatUser = res?.data || [];
        this.cachedSearchResult = this.newChatUser;
        this.showNewChatList = true;
      });
  }

  // toggle the "New Chat" dropdown
  chatOption() {
    this.showNewChatDropdown = !this.showNewChatDropdown;
  }

  // Handle New Chat dropdown selection
  onNewChatSelect(type: 'user' | 'merchant' | 'fellowship'| 'affiliates') {
    this.chatStatus = false;
    // Map dropdown types to existing backend tabs
    const tab = type === 'user' ? 'People' : type === 'merchant' ? 'Partners' : 'People';
    this.activeTab = tab;
    this.authService
      .getData(`/user/getUserFriends?role=Community&tab=${tab}`)
      .subscribe(
        (res: any) => {
          this.newChatUser = res?.data || [];
          this.cachedSearchResult = this.newChatUser;
          this.showNewChatList = true;
        },
        () => {
          this.newChatUser = [];
          this.showNewChatList = true;
        }
      );
  }
  toggleNewChatList() {
    this.showNewChatList = !this.showNewChatList;
  }

  closeNewChatList() {
    this.showNewChatList = false;
  }

  scrollToBottom(): void {
    if (this.chatContainer) {
      try {
        this.chatContainer.nativeElement.scrollTo({
          top: this.chatContainer.nativeElement.scrollHeight,
          behavior: 'smooth',
                });
      } catch (err) {
        console.error('Error scrolling to bottom:', err);
      }
    }
  }

  isValidObjectId(id: string): boolean {
    return typeof id === 'string' && /^[0-9a-fA-F]{24}$/.test(id);
  }

  checkImage(user: User) {
    const photo = user?.postOwner?.photo;
    if (photo) {
      const url = photo.includes('http')
        ? photo
        : `${environment.imgUrl}/${photo}`;
      this.chatUserImage = url;
    } else {
      this.chatUserImage = '';
    }
  }

  initiateFellowshipChat(user: User) {
    try {
      const base: any = (user as any)?.user || user; // unwrap if nested under `user`
      const contactUserId: any = base?._id || base?.id || base?.merchantId;
      this.activeMessageSenderId=null
      const postOwnerId = this.loginUser;
      this.showNewChatList = false;
      if (
        !this.isValidObjectId(contactUserId) ||
        !this.isValidObjectId(postOwnerId)
      ) {
        this.chatStatus = false;
        this.chat = [];
        return;
      }
      this.newMessage = '';
      this.userName = `${base.firstName || ''} ${base.lastName || ''} ${base.userName || base.name || ''}`.trim();
      this.activeUser = [base].filter(Boolean) as any;
      this.postId = '';
      this.contactUser = contactUserId;
      const query = {
        contactUser: contactUserId,
        postOwner: postOwnerId,
        chatType: 'business',
      };
      this.getUserChat(query);
    } catch (err) {
      console.log('errr', err);
    }
  }

  getUserChat(postData: any) {
    const postOwner = postData?.postOwner;
    const contactUser = postData?.contactUser;
    this.contactUser=contactUser
    if (
      !this.isValidObjectId(postOwner) ||
      !this.isValidObjectId(contactUser)
    ) {
      this.chatStatus = false;
      this.chat = [];
      return;
    }

    this.authService
      .getPostMessages(
        `/postChat/getMerchantById?postOwner=${postOwner}&contactUser=${contactUser}`
      )
      .subscribe(
        (res: any) => {
          if (res.code === 200 && res.data) {
            this.chatId = res.data._id;
            this.chat = res.data.message || [];
            this.postChat = [res.data];
            this.userProfile = this.userName
              .split(' ')
              .map((n: string) => n[0])
              .join('');
            this.checkImage(res.data);
            this.chat;
            this.postId = res.data.postId || '';
            this.chatStatus = true;
            setTimeout(() => this.scrollToBottom(), 0);
          } else {
            this.chatStatus = false;
            this.chat = [];
          }
        },
        () => {
          this.chatStatus = false;
          this.chat = [];
        }
      );
  }

  onImageError(event: any) {
    event.target.src = '../../../../assets/person.png';
  }

  getUserFriendsList() {
    if (this.activeTab === 'Ministries') {
      this.authService
        .getData(`/user/getUserFriends?role=Community&tab=${this.activeTab}`)
        .subscribe((res: any) => {
          this.partnersUserList = res?.data || [];
          this.cachedSearchResult = this.partnersUserList;
        });
      return;
    }
    if (this.activeTab === 'Merchants') {
      this.authService
        .getData(`/user/getUserFriends?role=Community&tab=merchant`)
        .subscribe((res: any) => {
          const list = (res?.data || []).map((e: any) => e?.user || e);
          this.partnersUserList = list;
          this.cachedSearchResult = this.partnersUserList;
        });
      return;
    }
    if (this.activeTab === 'Public') {
      // Followers list
      this.authService.getData(`/user/getUserFriends?role=Community&tab=public`).subscribe((res: any) => {
        const items = res?.data || [];
        this.publicUsers = items;
        this.cachedSearchResult = this.publicUsers;
      });
      return; 
    }
    if (this.activeTab === 'Affiliate') {
      // Affiliated users list
      this.authService
      .getData(`/user/getUserFriends?role=Community&tab=${this.activeTab}`)
      .subscribe((res: any) => {
        // Normalize: some APIs may return { user: {...} }, ensure we display the actual user object
        const list = (res?.data || []).map((e: any) => e?.user || e);
        this.affiliateUsers = list;
        this.cachedSearchResult = this.affiliateUsers;
      });
      return;
    }
  }

getAllTabUsers() {
  const people$ = this.authService.getData(
    `/user/getUserFriends?role=Community&tab=People`
  );

  const public$ = this.authService.getData(
    `/user/getUserFriends?role=Community&tab=public`
  );

  const affiliates$ = this.authService.getData(
    `/user/getUserFriends?role=Community&tab=Affiliate`
  );

  forkJoin([people$, public$, affiliates$]).subscribe(
    ([peopleRes, publicRes, affiliatesRes]: any) => {
      const people = peopleRes?.data || [];
      const publics = publicRes?.data || [];
      const affiliates = affiliatesRes?.data || [];

      const merged = [...people, ...publics, ...affiliates];

      // Deduplicate by id
      const uniqueMap = new Map();
      for (let user of merged) {
        const id = user._id || user.id;
        const idStr = typeof id === 'object' ? id.toString() : String(id);

        if (!uniqueMap.has(idStr)) {
          uniqueMap.set(idStr, user);
        }
      }

      this.allTabsUserList = Array.from(uniqueMap.values());
      this.cachedSearchResult = this.allTabsUserList;
    }
  );
}

  getSelectedTab(tab: any) {
    this.activeTab = tab;
    this.chatStatus = false;
    // Clear search input and cached results to force fresh view per tab
    this.searchTerm = '';
    this.cachedSearchResult = [];
    // Do not reuse previously filtered arrays when switching tabs
    if (tab === 'People') { this.friends = []; }
    if (tab === 'Public') { this.publicUsers = []; }
    if (tab === 'Affiliate') { this.affiliateUsers = []; }
    if (tab === 'Merchants') { this.partnersUserList = []; }
    if (tab === 'all') { this.allTabsUserList = []; }
    if (tab == 'People'  || tab == 'Ministries' || tab == 'Public' || tab == 'Affiliate' || tab == 'Merchants') {
      this.getUserFriendsList();
    } else if (tab == 'all') {
      this.getAllTabUsers();
    }
  }

  setUrl(user: any) {
    if (user?.photo?.includes('http')) return user.photo;
    if (user?.photo)
      return `${environment.imgUrl}${user.photo.split('uploads')[1]}`;
  }

  sendMessage() {
    let contactUserId = this.contactUser?.id || this.contactUser?._id|| this.contactUser;
    if (!contactUserId || !this.isValidObjectId(contactUserId)) {
      return;
    }
    if (!this.newMessage?.trim()) {
      return;
    }

    const senderId = this.loginUser;
    const messageData = {
      message: this.newMessage.trim(),
      senderId,
      receiverId: contactUserId,
      markAsRead: false,
      createdAt: new Date().toISOString(),
    };

    this.authService
      .postData('/postChat/sendMessage', {
        postOwner: senderId,
        contactUser: contactUserId,
        postId: '',
        chatType: 'business',
        message: messageData,
      })
      .subscribe(
        (res: any) => {
          if (res.code === 200 && res.data?.message) {
            this.newMessage = '';
            this.chat = res.data.message;
            setTimeout(() => this.scrollToBottom(), 0);
          }
        },
        (error) => {
          console.error('Error saving message:', error);
        }
      );
  }
}
